import React from 'react';

const AboutSection = () => {
  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2>About Us</h2>
            <p className="lead" style={{ fontSize: '1.1em', color: '#666', marginBottom: '28px', marginTop: '8px' }}>
              BSB is a tech-driven industrial raw material distribution platform with an integrated supply chain ecosystem,
              focused on transforming how B2B trade operates.
            </p>

            <div className="about-timeline">
              <div className="timeline-item">
                <div className="timeline-year">2018</div>
                <h4>Global trade &amp; polymer focus</h4>
                <p>
                  The journey began in <strong>2018</strong>, when <strong>Nalin Bhavsar</strong> entered the global trade
                  business with a strong focus on the polymer industry, gaining deep market understanding and building
                  international connections.
                </p>
              </div>

              <div className="timeline-item">
                <div className="timeline-year">2020</div>
                <h4>India &amp; UAE footprint</h4>
                <p>
                  In <strong>2020</strong>, the foundation was strengthened with the establishment of group companies in
                  India and UAE, enabling seamless cross-border trade and operational scalability.
                </p>
              </div>

              <div className="timeline-item">
                <div className="timeline-year">2021</div>
                <h4>Integrated distribution platform</h4>
                <p>
                  By <strong>2021</strong>, BSB took a major leap by developing a technology-driven integrated distribution
                  and supply chain platform, connecting buyers, suppliers, logistics, and trade finance into one unified
                  ecosystem.
                </p>
              </div>

              <div className="timeline-item">
                <div className="timeline-year">Today</div>
                <h4>Innovation in polymer trading &amp; logistics</h4>
                <p>
                  Today, BSB is leading innovation in polymer trading, supply chain, and logistics, with a clear vision to
                  build a scalable, transparent, and AI-powered industrial trade network.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
